import { lireJeton } from '../session';

/**
 * Preparer une photo avant l'envoi : REDIMENSIONNEE cote client (grand cote 1568 px,
 * JPEG) — le modele n'a pas besoin de plus, la base reste legere, et l'envoi passe
 * sous la limite du serveur meme depuis un telephone a 50 megapixels.
 *
 * Sans canvas utilisable (vieux navigateur, environnement de test), le fichier part
 * tel quel : le garde-fou de taille du schema partage tranche alors.
 */

const GRAND_COTE_MAX = 1568;

function lireBase64(blob: Blob): Promise<string> {
  return new Promise((resoudre, rejeter) => {
    const lecteur = new FileReader();
    lecteur.onload = () => {
      const resultat = lecteur.result as string;
      // « data:image/jpeg;base64,AAAA... » -> la partie utile seulement.
      resoudre(resultat.slice(resultat.indexOf(',') + 1));
    };
    lecteur.onerror = () => rejeter(new Error('Photo illisible'));
    lecteur.readAsDataURL(blob);
  });
}

export async function preparerPhoto(
  fichier: File,
): Promise<{ imageBase64: string; imageMimeType: 'image/jpeg' | 'image/png' | 'image/webp' }> {
  if (typeof createImageBitmap === 'function' && typeof document !== 'undefined') {
    try {
      const bitmap = await createImageBitmap(fichier);
      const facteur = Math.min(1, GRAND_COTE_MAX / Math.max(bitmap.width, bitmap.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(bitmap.width * facteur);
      canvas.height = Math.round(bitmap.height * facteur);
      const contexte = canvas.getContext('2d');
      if (contexte !== null) {
        contexte.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
        const blob = await new Promise<Blob | null>((resoudre) =>
          canvas.toBlob(resoudre, 'image/jpeg', 0.82),
        );
        if (blob !== null) {
          return { imageBase64: await lireBase64(blob), imageMimeType: 'image/jpeg' };
        }
      }
    } catch {
      // Format exotique ou canvas indisponible : on tombe sur le fichier tel quel.
    }
  }
  const mimeType =
    fichier.type === 'image/png' || fichier.type === 'image/webp' ? fichier.type : 'image/jpeg';
  return { imageBase64: await lireBase64(fichier), imageMimeType: mimeType };
}

/**
 * Charge la photo d'un message en URL locale affichable. Un <img src> n'envoie pas le
 * jeton d'authentification : on passe par fetch, puis par un blob local.
 */
export async function chargerPhotoDeBoite(elementId: string): Promise<string> {
  const jeton = lireJeton();
  const reponse = await fetch(`/boite/${encodeURIComponent(elementId)}/image`, {
    headers: jeton === null ? {} : { authorization: `Bearer ${jeton}` },
  });
  if (!reponse.ok) throw new Error('Photo indisponible');
  return URL.createObjectURL(await reponse.blob());
}
